import api from "../services/api";

const path = "imagempontoacesso";

export const getImagesPointsAccess = async ({ IdPontoAcesso }) => {
  const filter = IdPontoAcesso ? `?IdPontoAcesso=${IdPontoAcesso}` : "";
  return await api.get(`${path}${filter}`);
};

export const getImagesPointsAccessForDisplay = async ({ IdPontoAcesso }) => {
  const filter = IdPontoAcesso ? `?IdPontoAcesso=${IdPontoAcesso}` : "";
  return await api.get(`${path}/exibicao${filter}`);
};

export const findImagePointAccess = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editImagePointAccess = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createImagePointAccess = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteImagePointAccess = async ({ idPointAccess }) => {
  const filter = idPointAccess ? `?IdPontoAcesso=${idPointAccess}` : "";
  return await api.delete(`${path}${filter}`);
};
